/* PLP filter drawer (9 Sep, rebuilt to the FILTER & SORT reference).

   One column of accordions rather than two panes, sort folded in as the first
   group. The filtering itself stays Shopify's: a plain GET to the collection
   URL. This file drives the drawer, the merged-value checkboxes, the tag
   params and the live count. */
(function () {
  'use strict';

  var form = document.getElementById('PmFacets');
  var drawer = document.querySelector('[data-pm-filter]');
  var toggle = document.querySelector('[data-pm-facets-toggle]');
  if (!drawer || !form) return;

  /* ---- open / close, with a deep link so the drawer can be linked directly:
     #filter on any collection URL, or ?drawer=filter ---- */
  var lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    var f = drawer.querySelector('summary, button, input');
    if (f) f.focus();
  }
  function close() {
    drawer.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  if (toggle) toggle.addEventListener('click', open);
  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-pm-filter-close]')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) close();
  });
  try {
    var wantsOpen = window.location.hash === '#filter' ||
      /(?:\?|&)drawer=filter\b/.test(window.location.search);
    if (wantsOpen) open();
  } catch (err) { /* a malformed URL must not cost us the drawer */ }

  /* ---- a merged row drives every underlying value ----
     The catalogue stores "Blue" and "blue" as separate option values. One row
     shows per lower-cased label; ticking it ticks all of its real inputs,
     which are what actually submit. Tag rows carry their own name and submit
     directly, so they are left alone. */
  drawer.addEventListener('change', function (e) {
    var master = e.target.closest('[data-pm-master]');
    if (master && !master.hasAttribute('data-pm-tag')) {
      var wrap = master.closest('.pm-filter__opt');
      wrap.querySelectorAll('.pm-filter__real input').forEach(function (real) {
        real.checked = master.checked;
      });
    }
    paintGroups();
    scheduleCount();
  });

  /* ---- each accordion shows how many of its values are on ---- */
  function paintGroups() {
    drawer.querySelectorAll('.pm-filter__group').forEach(function (g) {
      var name = g.querySelector('.pm-filter__gname');
      if (!name || g.querySelector('input[type="radio"]')) return;
      var on = g.querySelectorAll('.pm-filter__master:checked').length +
        Array.prototype.slice.call(g.querySelectorAll('input[type="number"]'))
          .filter(function (i) { return i.value !== ''; }).length;
      var base = name.dataset.base || (name.dataset.base = name.firstChild.textContent.trim().replace(/\s*\(\d+\)$/, ''));
      name.firstChild.textContent = on ? base + ' (' + on + ')' : base;
    });
  }

  /* ---- live count: ask the server what the current selection returns.
     collection.products_count already reflects applied facets, so the
     filtered page's own data-pm-total is the honest number. ---- */
  var out = drawer.querySelector('[data-pm-apply-count]');
  var apply = drawer.querySelector('[data-pm-apply]');
  var timer = null;
  var seq = 0;

  function query() {
    var data = new FormData(form);
    var parts = [];
    data.forEach(function (v, k) {
      if (v !== '') parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
    });
    return parts.join('&');
  }
  function scheduleCount() {
    if (!out) return;
    clearTimeout(timer);
    timer = setTimeout(runCount, 300);
  }
  function runCount() {
    var mine = ++seq;
    var url = (form.dataset.pmBase || form.getAttribute('action')) + '?' + query();
    if (apply) apply.classList.add('is-busy');
    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (mine !== seq || !html) return;          // a newer request won
        var m = html.match(/data-pm-total="(\d+)"/);
        if (m) out.textContent = m[1];
      })
      .catch(function () { /* leave the last known count */ })
      .then(function () { if (mine === seq && apply) apply.classList.remove('is-busy'); });
  }

  paintGroups();
})();

/* Infinite scroll on listings (Parshva, 8 Oct). When the "Load more" row is
   within about a screen of view, or already scrolled past, fetch its URL,
   append that page's cards to this grid and swap in the next page's row;
   stop when there is none. Scroll driven, not IntersectionObserver: an
   observer never fires when a fling or a jump to the footer skips straight
   past the row. One request at a time. Saved wishlist hearts are painted on
   the new cards, since parman-ui.js paints only the hearts present at load. */
(function () {
  var grid = document.querySelector('[data-pm-plp-grid]');
  if (!grid) return;
  var busy = false, tick = false;
  var saved = function () { try { return JSON.parse(localStorage.getItem('pm-wishlist')) || []; } catch (e) { return []; } };
  var load = function (more) {
    var link = more.querySelector('a[href]');
    if (!link) return;
    busy = true;
    more.classList.add('is-loading');
    fetch(link.href, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-pm-plp-grid]');
        var list = saved();
        if (next) {
          Array.prototype.slice.call(next.children).forEach(function (card) {
            card.querySelectorAll('img[loading="eager"]').forEach(function (img) { img.loading = 'lazy'; img.removeAttribute('fetchpriority'); });
            card.querySelectorAll('[data-pm-wishlist]').forEach(function (b) {
              b.setAttribute('aria-pressed', list.indexOf(b.dataset.pmWishlist) !== -1 ? 'true' : 'false');
            });
            grid.appendChild(document.importNode(card, true));
          });
        }
        var nextMore = doc.querySelector('[data-pm-plp-more]');
        if (nextMore) more.replaceWith(document.importNode(nextMore, true)); else more.remove();
        busy = false;
        check();
      })
      .catch(function () { busy = false; more.classList.remove('is-loading'); });
  };
  var check = function () {
    tick = false;
    if (busy) return;
    var more = document.querySelector('[data-pm-plp-more]');
    if (!more) { removeEventListener('scroll', onScroll); return; }
    if (more.getBoundingClientRect().top < innerHeight + 900) load(more);
  };
  var onScroll = function () { if (!tick) { tick = true; requestAnimationFrame(check); } };
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll, { passive: true });
  check();
})();
